import type { SyntheticEvent } from "react";
import { primaryItems, unloggedItems } from "./navigation";

/** One segment of a page's parent trail. Every segment links to its own route. */
export type PageParent = {
  label: string;
  href: string;
  /**
   * Runs instead of following `href` when the parent is a step of the same route (the cart behind the payment step).
   * `href` is still rendered so the segment stays a real link.
   */
  onClick?: () => void;
};

/** The drawer entry at `href` as a trail segment, so a parent is always named the way the navigation names it. */
export function navigationParent(href: string): PageParent {
  const item = [...primaryItems, ...unloggedItems].find((entry) => entry.href === href);

  if (!item) {
    throw new Error(`No navigation item is registered for ${href}`);
  }

  return { label: item.label, href };
}

export function handleParentClick(event: SyntheticEvent, parent: PageParent) {
  if (!parent.onClick) {
    return;
  }

  event.preventDefault();
  parent.onClick();
}
